import { GatewayRequestType, GatewayResponseType } from '../web-socket/types';

import { BaseMDSSubscriptionService } from './BaseMDSSubscription.service';

/**
 * Market Data Summary Subscription Service
 */
export class MDSSubscriptionService extends BaseMDSSubscriptionService {
  private static instance: MDSSubscriptionService;

  // Make the constructor private, to have a single instance
  // eslint-disable-next-line no-useless-constructor
  private constructor() {
    super();
  }

  static getInstance(): MDSSubscriptionService {
    if (!this.instance) {
      this.instance = new MDSSubscriptionService();
    }

    return this.instance;
  }

  protected getSubscriptionRequestType = (): GatewayRequestType => GatewayRequestType.MarketDataSummary;

  protected getUnsubscriptionRequestType = (): GatewayRequestType => GatewayRequestType.None;

  protected getResponseType = (): GatewayResponseType => GatewayResponseType.DataSummaryResponse;
}
